import React from 'react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible';
import { CompareResults } from '../CompareResults';
import { StepHeader } from '../StepHeader';
import { getStepNumber, toggleStep } from '../../utils/rankAListHelpers';
import { ChevronDown } from 'lucide-react';

interface CompareResultsStepProps {
  step: number;
  expandedSteps: number[];
  setExpandedSteps: (steps: number[]) => void;
  approach: 'prediction' | 'similarity';
  jobId: string;
}

export const CompareResultsStep: React.FC<CompareResultsStepProps> = ({
  step,
  expandedSteps,
  setExpandedSteps,
  approach,
  jobId
}) => {
  const stepNumber = approach === 'prediction' ? 8 : 8;
  const isOpen = expandedSteps.includes(stepNumber);
  
  return (
    <Collapsible 
      open={isOpen} 
      className="border border-slate-600 rounded-lg bg-slate-800"
    >
      <CollapsibleTrigger asChild>
        <button className="w-full" onClick={() => toggleStep(stepNumber, expandedSteps, setExpandedSteps)}>
          <div className="flex items-center justify-between w-full">
            <StepHeader 
              stepNumber={getStepNumber(stepNumber - 1, approach)} 
              title="Compare Results" 
              status={step >= stepNumber ? 'current' : 'pending'}
              isOpen={isOpen}
            />
            <ChevronDown 
              className={`h-5 w-5 text-slate-400 transition-transform duration-200 mr-4 ${
                isOpen ? 'rotate-180' : ''
              }`}
            />
          </div>
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent className="px-4 pb-4">
        <CompareResults 
          currentJobId={step >= stepNumber ? jobId : 'job_preview_123'}
          disabled={step < stepNumber}
        />
      </CollapsibleContent>
    </Collapsible>
  );
}; 